import { render, staticRenderFns } from "./SetupShop.vue?vue&type=template&id=52cd7715&scoped=true"
import script from "./SetupShop.vue?vue&type=script&lang=js"
export * from "./SetupShop.vue?vue&type=script&lang=js"
import style0 from "./SetupShop.vue?vue&type=style&index=0&id=52cd7715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd7715",
  null
  
)

export default component.exports